import { PiSoundcloudLogoFill } from "react-icons/pi";
import { BsSpotify } from "react-icons/bs";
import { SiApplemusic } from "react-icons/si";
import { FaFacebook } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaBandcamp } from "react-icons/fa6";
import { seoConfig } from "../layouts/seoConfig";
import { aboutContent } from "../data/aboutContent";

export const PROJECTS = {
  HARDCORE_BUDDHIST: "hardcorebuddhist",
  SWARATRIP: "swaratrip",
  MINDSEX: "mindsex",
};

// First, define the constant properties (title and icon)
const socialPlatforms = {
  BANDCAMP: {
    title: "BANDCAMP",
    Icon: FaBandcamp,
  },
  SOUNDCLOUD: {
    title: "SOUNDCLOUD",
    Icon: PiSoundcloudLogoFill,
  },
  SPOTIFY: {
    title: "SPOTIFY",
    Icon: BsSpotify,
  },
  APPLE_MUSIC: {
    title: "APPLE MUSIC",
    Icon: SiApplemusic,
  },
  FACEBOOK: {
    title: "FACEBOOK",
    Icon: FaFacebook,
  },
  INSTAGRAM: {
    title: "INSTAGRAM",
    Icon: FaInstagramSquare,
  },
  YOUTUBE: {
    title: "YOUTUBE",
    Icon: FaYoutube,
  },
};

// Define links for each layout
export const layoutLinks = {
  hb: {
    BANDCAMP: "https://hardcorebuddhist.bandcamp.com/",
    SOUNDCLOUD: "https://soundcloud.com/hardcorebuddhist",
    SPOTIFY: "https://open.spotify.com/artist/6UMbXpVgril0PEbolGb60U",
    APPLE_MUSIC:
      "https://music.apple.com/us/artist/hardcore-buddhist/1407432485",
    FACEBOOK: "https://www.facebook.com/hardcorebuddhist/",
    INSTAGRAM: "https://www.instagram.com/hardcore_buddhist/",
    YOUTUBE: "https://www.youtube.com/channel/UC_uTUpstHg33jwr6OQtdalw",
  },
  swaratrip: {
    BANDCAMP: "https://swaratrip.bandcamp.com/",
    SOUNDCLOUD: "https://soundcloud.com/swaratrip",
    SPOTIFY: "https://open.spotify.com/artist/3wGbxywaL7ToMqjUTFgqJj",
    APPLE_MUSIC: "https://music.apple.com/us/artist/swaratrip/1531686943",
    FACEBOOK: "https://www.facebook.com/swaratrip/",
    INSTAGRAM: "https://www.instagram.com/swaratrip/",
    YOUTUBE: "https://www.youtube.com/@swaratrip4463",
  },
  mindsex: {
    BANDCAMP: "https://mindsex.bandcamp.com/",
    SOUNDCLOUD: "https://soundcloud.com/mindsex_music",
    SPOTIFY: "https://open.spotify.com/artist/1omXwWrlVSFfvhNa4hmBNd",
    APPLE_MUSIC: "https://music.apple.com/us/artist/mindsex/1786081189",
    FACEBOOK: "https://www.facebook.com/mindsex.music/",
    INSTAGRAM: "https://www.instagram.com/mindsex.music/",
    YOUTUBE: "https://www.youtube.com/@MindsexMusic",
  },
};

// Function to generate the menu for a specific layout
export const getIconsMenu = (layoutName) => {
  const links = layoutLinks[layoutName];
  return Object.entries(socialPlatforms).map(([key, platform]) => ({
    ...platform,
    link: links[key],
  }));
};

const COMMON_CONFIG = {
  followersSheetId: "153MkdAqWpGMzeJ9JIuvddqu_25pRnJUp5JJb9r04Vdk",
  followersScriptUrl:
    "https://script.google.com/macros/s/AKfycbzHp7QocEi_NzyaSfRhoE69-gdfGbrUAjwbCvUuAnLwweD_04Myc4NEFsNKy7a-tH45eQ/exec",
};

export const layoutConfigs = {
  [PROJECTS.HARDCORE_BUDDHIST]: {
    title: "HARDCORE BUDDHIST",
    fontClass: "hb-font",
    path: "/hardcorebuddhist",
    musicStyle: "[psybient, progressive chill out]",
    media: {
      theme: "theme-hb",
      image: "image-hb",
    },
    logos: {
      logoBack: "/assets/mandala.webp",
      logoFront: "/assets/logo-hb.webp",
    },
    latestMix:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1979265983&color=%23ff5500&inverse=true&auto_play=false&show_user=true",
    iconsMenu: getIconsMenu("hb"),
    artistId: "6UMbXpVgril0PEbolGb60U",
    googleSheetId: "1voQRXLRYJuLahzkzVIW2BaaxxDY6tOqVi4gOT11DehU",
    followersConfig: {
      ...COMMON_CONFIG,
      sheetName: "Followers-Hardcore Buddhist",
    },
    SEO: seoConfig.hardcorebuddhist,
    projectDescription: aboutContent.hb_about,
  },

  [PROJECTS.SWARATRIP]: {
    title: "SWARATRIP",
    fontClass: "swaratrip-font",
    path: "/swaratrip",
    musicStyle: "[psytrance, goa trance]",
    media: {
      theme: "theme-swaratrip",
      image: "image-swaratrip",
    },
    logos: {
      logoBack: "/assets/mandala-swaratrip.svg",
      logoFront: "/assets/logo-front-swaratrip.svg",
    },
    latestMix:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1266525700&color=%23ff5500&inverse=true&auto_play=false&show_user=true",
    iconsMenu: getIconsMenu("swaratrip"),
    artistId: "3wGbxywaL7ToMqjUTFgqJj",
    googleSheetId: "1yJykyVqPUO59nJZdeQUgC58TvbJBpDJp2OOnv5b799k",
    followersConfig: {
      ...COMMON_CONFIG,
      sheetName: "Followers-Swaratrip",
    },
    SEO: seoConfig.swaratrip,
    projectDescription: aboutContent.swaratrip_about,
  },

  [PROJECTS.MINDSEX]: {
    title: "MINDSEX",
    fontClass: "mindsex-font",
    path: "/mindsex",
    musicStyle: "[progressive fusion]",
    media: {
      theme: "theme-mindsex",
      image: "image-mindsex",
    },
    logos: {
      logoBack: "/assets/mandala-mindsex.svg",
      logoFront: "/assets/logo-front-mindsex.svg",
    },
    latestMix:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2094858396&color=%23ff5500&inverse=true&auto_play=false&show_user=false",
    iconsMenu: getIconsMenu("mindsex"),
    artistId: "1omXwWrlVSFfvhNa4hmBNd",
    googleSheetId: "1-U-VXyP1PJakylnxabzgvAnL6y8GyXj5wbBApqZ5t54",
    followersConfig: {
      ...COMMON_CONFIG,
      sheetName: "Followers-Mindsex",
    },
    SEO: seoConfig.mindsex,
    projectDescription: aboutContent.mindsex_about,
  },
};
